<template>
  <div class="features">
    <div class="header container">
      <img class="wave-top" src="@/assets/img/wave_top_page.png" />
      <img class="wave-top-mobile" src="@/assets/img/wave_top_mobile.png" />
      <h2 class="section-title">Upmood Features</h2>
      <div class="circle-light-yellow animate-growing"></div>
      <div class="circle-blue animate-shrinking"></div>
    </div>
    <div class="section1 container">
      <div class="image-wrapper  effect-move-up">
        <lottie
          :options="moodFeedOptions"
          v-on:animCreated="moodFeedAnimation"
        />
      </div>
      <div class="content">
        <h1 class="main-title">Mood Feed</h1>
        <p class="description">
          Upmood gives an insight on your heart rate, stress level, vitality
          levels, and emotion to recognize oneself, characters, and feelings to
          properly manage your emotions.
        </p>
      </div>
      <div class="circle-cyan animate-shrinking"></div>
    </div>
    <div class="section2 container">
      <div class="content">
        <h1 class="main-title">Moodstream</h1>
        <p class="description">
          View a detailed summary of your emotions, as well as your progress and
          trends over time with Moodstream. You can also view your friend’s and
          family’s by visiting their own stream.
        </p>
      </div>
      <div class="image-wrapper  effect-move-up">
        <lottie
          :options="moodStreamOptions"
          v-on:animCreated="moodStreamAnimation"
        />
      </div>
      <div class="circle-light-yellow circle1 animate-shrinking"></div>
      <div class="circle-light-yellow circle2 animate-growing"></div>
      <div class="circle-orange animate-shrinking"></div>
    </div>
    <div class="section3 container">
      <div class="image-wrapper  effect-move-up">
        <lottie
          :options="sendReactionOptions"
          v-on:animCreated="sendReactionAnimation"
        />
      </div>
      <div class="content">
        <h1 class="main-title">Send Reaction</h1>
        <p class="description">
          Upmood allows you to connect, react and share without saying a word.
          Add as many friends and know what they’re feeling as it happens.
        </p>
      </div>
    </div>
    <div class="section4 container">
      <div class="content">
        <h1 class="main-title">Groups</h1>
        <p class="description">
          Upmood ables you to create groups with your friends and families to
          see their emotions in one place, with a notification whenever a person
          makes an update so you won’t miss out on what matters.
        </p>
      </div>
      <div class="image-wrapper  effect-move-up">
        <lottie :options="groupsOptions" v-on:animCreated="groupsAnimation" />
      </div>
    </div>
    <div class="section5 container">
      <div class="content">
        <h1 class="main-title">Stickers</h1>
        <p class="description">
          Interact with your friends and family with our tailor-made stickers
          featuring a spectrum of characters representing all sorts of emotions
          and reactions.
        </p>
      </div>
      <div class="image-wrapper  effect-move-up">
        <lottie
          :options="stickersOptions"
          v-on:animCreated="stickersAnimation"
        />
      </div>
      <div class="circle-green animate-growing"></div>
      <div class="circle-orange animate-growing"></div>
      <img class="wave-bottom" src="@/assets/img/wave_bottom_page.png" />
    </div>
  </div>
</template>

<script>
import Lottie from "@/components/Lottie";
import * as MoodFeed from "@/assets/animations/moodfeed/moodfeed.json";
import * as MoodStream from "@/assets/animations/moodstream/moodstream.json";
import * as SendReaction from "@/assets/animations/sendreaction/sendreaction.json";
import * as Groups from "@/assets/animations/groups/groups.json";
import * as Stickers from "@/assets/animations/stickers/stickers.json";

export default {
  data() {
    return {
      moodFeedOptions: {
        animationData: MoodFeed.default,
        loop: true,
        autoplay: false
      },
      moodStreamOptions: {
        animationData: MoodStream.default,
        loop: true,
        autoplay: false
      },
      sendReactionOptions: {
        animationData: SendReaction.default,
        loop: true,
        autoplay: false
      },
      groupsOptions: {
        animationData: Groups.default,
        loop: true,
        autoplay: false
      },
      stickersOptions: {
        animationData: Stickers.default,
        loop: true,
        autoplay: false
      }
    };
  },

  activated() {
    this.moodFeedPlay();
    this.moodStreamPlay();
    this.sendReactionPlay();
    this.groupsPlay();
    this.stickersPlay();
  },

  deactivated() {
    this.moodFeedStop();
    this.moodStreamStop();
    this.sendReactionStop();
    this.groupsStop();
    this.stickersStop();
  },

  components: {
    lottie: Lottie
  },

  methods: {
    moodFeedAnimation(anim) {
      this.moodFeed = anim;
    },

    moodFeedStop() {
      this.moodFeed.stop();
    },

    moodFeedPlay() {
      this.moodFeed.play();
    },

    moodStreamAnimation(anim) {
      this.moodStream = anim;
    },

    moodStreamStop() {
      this.moodStream.stop();
    },

    moodStreamPlay() {
      this.moodStream.play();
    },

    sendReactionAnimation(anim) {
      this.sendReaction = anim;
    },

    sendReactionStop() {
      this.sendReaction.stop();
    },

    sendReactionPlay() {
      this.sendReaction.play();
    },

    groupsAnimation(anim) {
      this.groups = anim;
    },

    groupsStop() {
      this.groups.stop();
    },

    groupsPlay() {
      this.groups.play();
    },

    stickersAnimation(anim) {
      this.stickers = anim;
    },

    stickersStop() {
      this.stickers.stop();
    },

    stickersPlay() {
      this.stickers.play();
    }
  }
};
</script>

<style lang="scss" scoped>
.features {
  display: flex;
  flex-direction: column;
  align-items: center;

  .header {
    position: relative;
    margin-top: 160px;
    margin-bottom: 180px;
    text-align: center;

    @include mobile {
      padding: 0;
      margin: 40px 0;
    }

    h2.section-title {
      @include mobile {
        display: none;
      }
    }

    .wave-top {
      position: absolute;
      top: -215px;
      width: 100%;
      right: -325px;

      @include mobile {
        display: none;
      }
    }

    .wave-top-mobile {
      display: none;

      @include mobile {
        position: absolute;
        top: -140px;
        width: 115%;
        height: 100px;
        display: block;
      }
    }

    .circle-light-yellow {
      position: absolute;
      height: 83px;
      width: 83px;
      top: -145px;
      left: 260px;

      @include mobile {
        width: 50px;
        height: 50px;
        top: -70px;
        left: 95px;
      }
    }

    .circle-blue {
      height: 191px;
      width: 191px;
      position: absolute;
      left: -100px;
      bottom: -150px;

      @include mobile {
        height: 60px;
        width: 60px;
        left: -15px;
        bottom: -60px;
      }
    }
  }

  .section1,
  .section2,
  .section3,
  .section4,
  .section5 {
    height: 450px;
    margin-bottom: 50px;
    display: flex;
    justify-content: center;

    @include mobile {
      flex-direction: column;
      height: 600px;
      margin: 0;
    }

    h1.main-title {
      @include mobile {
        font-size: 35px;
      }
    }

    .content {
      display: flex;
      flex-direction: column;
      z-index: +1;

      @include mobile {
        order: 1;
      }

      p.description {
        @include mobile {
          font-size: 14px;
          line-height: 18px;
        }
      }
    }
  }

  .image-wrapper {
    width: 275px;
    height: 100%;
    z-index: +1;

    @include mobile {
      width: 200px;
      height: 300px;
      order: 2;
      margin: 20px 0;
    }
  }

  .section1 {
    position: relative;

    .content {
      width: 400px;
      margin-left: 90px;

      @include mobile {
        margin: 30px 0;
        width: 100%;
      }
    }

    .circle-cyan {
      position: absolute;
      height: 360px;
      width: 360px;
      bottom: -50px;
      right: -170px;

      @include mobile {
        height: 300px;
        width: 300px;
        bottom: -30px;
        right: -190px;
      }
    }
  }

  .section2 {
    margin-top: 100px;
    position: relative;

    .content {
      width: 330px;
      flex-direction: column;
      margin-top: 75px;
      margin-right: 90px;

      @include mobile {
        margin: 30px 0;
        width: 100%;
      }
    }

    .image-wrapper {
      @include mobile {
        align-self: flex-end;
      }
    }

    .circle1 {
      position: absolute;
      height: 58px;
      width: 58px;
      top: -60px;
      right: 80px;
    }

    .circle2 {
      position: absolute;
      height: 499px;
      width: 499px;
      bottom: -210px;
      right: -350px;

      @include mobile {
        bottom: -645px;
        right: -350px;
      }
    }

    .circle-orange {
      position: absolute;
      height: 390px;
      width: 390px;
      left: -195px;
      bottom: -225px;

      @include mobile {
        left: -295px;
        bottom: -100px;
      }
    }
  }

  .section3 {
    .content {
      width: 300px;
      flex-direction: column;
      justify-content: center;
      margin-left: 90px;

      @include mobile {
        margin: 30px 0;
        width: 100%;
      }
    }
  }

  .section4 {
    .content {
      width: 320px;
      flex-direction: column;
      justify-content: center;
      margin-right: 90px;

      @include mobile {
        margin: 20px 0;
        width: 100%;
      }
    }

    .image-wrapper {
      @include mobile {
        align-self: flex-end;
      }
    }
  }

  .section5 {
    margin-top: 100px;
    margin-bottom: 300px;
    position: relative;

    @include mobile {
      margin-top: 0;
    }

    .content {
      width: 310px;
      flex-direction: column;
      justify-content: center;
      margin-right: 90px;

      @include mobile {
        margin: 30px 0;
        width: 100%;
      }
    }

    .circle-green {
      position: absolute;
      height: 451px;
      width: 451px;
      bottom: -90px;
      right: 50px;

      @include mobile {
        bottom: 550px;
        width: 350px;
        height: 350px;
        right: 100px;
      }
    }

    .circle-orange {
      position: absolute;
      height: 79px;
      width: 79px;
      bottom: 65px;
      left: 75px;

      @include mobile {
        height: 200px;
        width: 200px;
        bottom: -95px;
        left: 240px;
      }
    }

    .wave-bottom {
      position: absolute;
      left: -715px;
      bottom: -370px;
      width: 265%;

      @include mobile {
        bottom: -310px;
        width: 1150px;
        left: -340px;
        height: 200px;
      }
    }
  }
}
</style>
